import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { CaseStudies } from "@/components/CaseStudies";
import { Workflow } from "@/components/Workflow";
import { Footer } from "@/components/Footer";

const Home = () => {
  return (
    <div className="grain bg-[#0a0a0a] text-white min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Services />
        <CaseStudies />
        <Workflow />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
